import {createProgram} from "../primitiveHelpers.js";
import {primitiveFragShader, primitiveVertShader} from "../shaders/primitiveShader.js";
import mapboxgl from "mapbox-gl";
import * as THREE from "three";
import { getScalingFactor } from "../helpers.js";
import Stats from "three/addons/libs/stats.module.js";
import {array} from "three/tsl";
import {getPlateIndex, roundDownToNearest5} from "../helpers/index.js";


let program;
let vbo;

let goingUp = true;
let lineLength = 0;

let pos = [];
let pos2 = [];
let plateCreated = false;
let statsPanels;

const anchor = [0, 0];
const earthRadius = 1303.797293808806;

let plateTexture;

const plateSize = 1_000_000;
let earthsNipple = [];
const earthsNipple2 = [];

const numPoints = 500;
const numRotations = 100;
const scale = 50;
const angleIncrement = (Math.PI * 2 * numRotations) / numPoints;

let pos2Index = 0;



function splitAtDateline(points) {
  const newPoints = [];

  for (let i = 0; i < points.length - 1; i++) {
    const [lon1, lat1] = points[i];
    const [lon2, lat2] = points[i + 1];

    newPoints.push([lon1, lat1]);

    if (Math.abs(lon1 - lon2) > 180) {
      const crossLon = lon1 > 0 ? 180 : -180;
      let lon2Adjusted = lon2;

      if (lon2 < 0 && lon1 > 0) lon2Adjusted = lon2 + 360;
      if (lon2 > 0 && lon1 < 0) lon2Adjusted = lon2 - 360;

      const ratio = (crossLon - lon1) / (lon2Adjusted - lon1);

      const latIntercept = lat1 + ratio * (lat2 - lat1);

      newPoints.push([crossLon, latIntercept]);
      newPoints.push([-crossLon, latIntercept]);
    } else if ((lon1 < 0 && lon2 > 0) || (lon1 > 0 && lon2 < 0)) {

        // console.log(lon1, lon2)
        const ratio = -lon1 / (lon2 - lon1);
        const latIntercept = lat1 + ratio * (lat2 - lat1);

        if ((lon1 < 0 && lon2 > 0)) {
          newPoints.push([-0.0001, latIntercept]);
          newPoints.push([0.0001, latIntercept]);
        } else {
          newPoints.push([0.0001, latIntercept]);
          newPoints.push([-0.0001, latIntercept]);
        }


    }
  }

  newPoints.push(points[points.length - 1]);
  return newPoints;
}






const plates = [];
const plateSize2 = 5;

const latMin = -90;
const latMax = 90;
const lngMin = -180;
const lngMax = 180;

//  earthsNipple = [
//   [170, 0],
//   [168, 2],
//   [168, 2],
//   [175, 6],
//   [175, 6],
//   [179, 3],
//   [179, 3],
//   // [180, 0],
//   [-179, 4],
//   [-179, 4],
//   [-165, 10],
//   [-165, 10],
//   [-150, 20],
//   [-150, 20],
//   [172, 30]
// ]

earthsNipple = [
  [-10, 5],
  [-5, 10],
  [-5, 10],
  [5, 15],
  [5, 15],
  [15, 25],
  [15, 25],
  [25, 35],
  [25, 35],
  [-10, 45],
  [-10, 45],
  [20, 55],
  [20,55],
  [50, 55],
  [50, 55],
  [100, 44],
  [100, 44],
  [120, 64],
  [120, 64],
  [160, 34],
  [160, 34],
  [170, 10],
  [170, 10],
  [-175, -10],
  [-175, -10],
  [-155, -20],
  [-155, -20],
  [-160, 20],
  [-160, 20],
  [-170, 10],
  [-170, 10],
  [175, -10],
  [175, -10],
  [150, -30],
  [150, -30],
  [120, 20],
]

const splitLine = splitAtDateline(earthsNipple);
// const splitLine = earthsNipple;
 console.log("splitLine", splitLine);

let myMap;

export const linePrimitiveLayer = {
  id: 'line-primitive-layer',
  type: 'custom',
  onAdd: (map, gl) => {

    myMap = map;

    for (let lat = latMin; lat < latMax; lat += plateSize2) {
      for (let lng = lngMin; lng < lngMax; lng += plateSize2) {
        const swLat = lat;
        const swLng = lng;
        const neLat = Math.min(lat + plateSize2, latMax);
        const neLng = Math.min(lng + plateSize2, lngMax);

        plates.push({
          coords:[[swLat, swLng], [neLat, neLng]],
          plate: new mapboxgl.LngLatBounds(
            [ swLng, swLat],
            [ neLng, neLat]
          )
        });
      }
    }

    const plateArray = new Float32Array(162 * 16 * 16);

    plates.forEach(({ plate, coords }, i) => {
      const nw_merc = mapboxgl.MercatorCoordinate.fromLngLat(plate.getNorthWest(), 0);
      const sw_merc = mapboxgl.MercatorCoordinate.fromLngLat(plate.getSouthWest(), 0);
      const ne_merc = mapboxgl.MercatorCoordinate.fromLngLat(plate.getNorthEast(), 0);


      const tl_up = new THREE.Vector3().fromArray(plate.getNorthWest().toEcef(0));
      const br_up = new THREE.Vector3().fromArray(plate.getSouthWest().toEcef(0));
      const tr_up = new THREE.Vector3().fromArray(plate.getNorthEast().toEcef(0));
      const bl_up = new THREE.Vector3().fromArray(plate.getSouthEast().toEcef(0));


      const tl =  new THREE.Vector3(nw_merc.x, nw_merc.y, nw_merc.z);
      const tr =  new THREE.Vector3(ne_merc.x, ne_merc.y, ne_merc.z);
      const bl =  new THREE.Vector3(sw_merc.x, sw_merc.y, sw_merc.z);


      const offset = i * 16;

      plateArray.set([
        tl.x,
        tl.y,
        tr.x,
        bl.y,

        tl_up.x, tl_up.y, tl_up.z,
        tr_up.x, tr_up.y, tr_up.z,
        br_up.x, br_up.y, br_up.z,
        bl_up.x, bl_up.y, bl_up.z
      ], offset);
    });

    plateTexture = new THREE.DataTexture(
      plateArray,
      256, 162,
      THREE.RedFormat,
      THREE.FloatType
    );
    plateTexture.needsUpdate = true;


    vbo = gl.createBuffer();

    program = createProgram(gl, primitiveVertShader, primitiveFragShader);

    const altitude = 0;

    const stats1 = new Stats();
    stats1.showPanel(0);
    document.body.appendChild(stats1.dom);

    const stats2 = new Stats();
    stats2.showPanel(1);
    stats2.dom.style.left = '80px';
    document.body.appendChild(stats2.dom);

    const stats3 = new Stats();
    stats3.showPanel(2);
    stats3.dom.style.left = '160px';
    document.body.appendChild(stats3.dom);
    statsPanels = [stats1, stats2, stats3];

    for (
      let i = 0;
      i < splitLine.length;
      i++
    ) {


      const lon = splitLine[i][0];
      const lat = splitLine[i][1];


      if (lon !== undefined && lat !== undefined) {
        const merc = mapboxgl.MercatorCoordinate.fromLngLat(
          [lon, lat],
          altitude,
        );

        const roundedDown = roundDownToNearest5({
          x: lon, y: lat
        });

        pos.push(merc.x, merc.y, getPlateIndex(roundedDown));
      }
    }

    updateVboAndActivateAttrib(
      gl,
      program,
      vbo,
      // Add enough space in the buffer for new points
      [...pos, ...pos2],
      'position',
    );

    const width = 256;
    const height = 162;

    plateTexture = gl.createTexture();
    gl.bindTexture(gl.TEXTURE_2D, plateTexture);
    gl.texImage2D(
      gl.TEXTURE_2D,
      0,
      gl.R32F,
      width, height,
      0,
      gl.RED,
      gl.FLOAT,
      plateArray
    );


    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);

  },
  render: (
    gl,
    projectionMatrix,
    projection,
    globeToMercMatrix,
    transition,
    centerInMercator,
    pixelsPerMeterRatio,
  ) => {
    statsPanels.forEach(stats => stats.begin());
    gl.useProgram(program);
    gl.bindBuffer(gl.ARRAY_BUFFER, vbo);


    const location = gl.getUniformLocation(program, "u_plates");


    const mapCenter = myMap.getCenter();
    const nearDateLine = mapCenter.lng > 100 ||  mapCenter.lng < -100;
    const crossedDateLine = mapCenter.lng > 0;


    setUniform(gl, program, "u_near_dateline", nearDateLine);
    setUniform(gl, program, "u_crossed_dateline", crossedDateLine);



    gl.activeTexture(gl.TEXTURE0);
    gl.bindTexture(gl.TEXTURE_2D, plateTexture);
    gl.uniform1i(location, 0);



    // // Add one new point from pos2 each frame
    // if (pos2Index < pos2.length) {
    //   const newPoint = pos2.slice(pos2Index, pos2Index + 3);
    //
    //   // offset is in bytes
    //   const offset = pos.length * 4;
    //   const pos2Offset = pos2Index * 4;
    //
    //   gl.bufferSubData(gl.ARRAY_BUFFER, offset + pos2Offset, new Float32Array(newPoint));
    //   pos2Index += 3;
    // }



    if (projection && projection.name === 'globe') {
      if (!plateCreated) {
        setUniform(gl, program, "u_scale_factor", getScalingFactor(anchor[1]))
        setUniform(gl, program, "u_plate_up_scale", earthRadius)

        plateCreated = true;
      }


      activateAttrib(gl, program, 'position');

      setUniform(gl, program, "u_matrix_globe_merc", new THREE.Matrix4().fromArray(globeToMercMatrix));
      setUniform(gl, program, "projectionMatrix", new THREE.Matrix4().fromArray(projectionMatrix));

      setUniform(gl, program, "u_zoom_transition", transition);
      setUniform(gl, program, "u_pixelsPerMeterRatio", pixelsPerMeterRatio);
      setUniform(gl, program, "u_centerInMerc", new THREE.Vector2().fromArray(centerInMercator));

      // gl.drawArrays(gl.LINE_STRIP, 0, (pos.length + pos2Index) / 3);
      gl.drawArrays(gl.LINES, 0, pos.length / 3);
      // gl.drawArrays(gl.LINES, pos.length / 3, pos2.length / 3);
    } else {
      activateAttrib(gl, program, 'position');

      setUniform(gl, program, "projectionMatrix", new THREE.Matrix4().fromArray(projectionMatrix));
      setUniform(gl, program, "u_zoom_transition", 1);

      // gl.drawArrays(gl.LINE_STRIP, 0, (pos.length + pos2Index) / 3);

      gl.drawArrays(gl.LINES, 0, pos.length / 3);
      // gl.drawArrays(gl.LINES, pos.length / 3, pos2.length / 3);

    }
  statsPanels.forEach(stats => stats.end());
  }

}

function activateAttrib(
  gl,
  program,
  attribName,
) {
  const attribLoc = gl.getAttribLocation(program, attribName);
  gl.vertexAttribPointer(attribLoc, 3, gl.FLOAT, false, 0, 0);
  gl.enableVertexAttribArray(attribLoc);
}

function setUniform(gl, program, uniformName, value) {
  const location = gl.getUniformLocation(program, uniformName);
  if (!location) {
    console.warn(`Uniform ${uniformName} not found`);
    return;
  }

  if (value instanceof THREE.Matrix4) {
    gl.uniformMatrix4fv(location, false, value.elements);
  } else if (value instanceof THREE.Vector3) {
    gl.uniform3fv(location, value.toArray());
  } else if (value instanceof THREE.Vector2) {
    gl.uniform2fv(location, value.toArray());
  } else if (typeof value === "number") {
    gl.uniform1f(location, value);
  } else if (typeof value === "boolean") {
    gl.uniform1i(location, value ? 1 : 0);
  } else {
    console.error(`Incorrect uniform type for ${uniformName}`);
  }
}

function updateVboAndActivateAttrib(
  gl,
  prog,
  vbo,
  data,
  attribName,
) {
  gl.bindBuffer(gl.ARRAY_BUFFER, vbo);
  gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(data), gl.DYNAMIC_DRAW);

  const attribLoc = gl.getAttribLocation(prog, attribName);
  gl.vertexAttribPointer(attribLoc, 3, gl.FLOAT, false, 0, 0);
  gl.enableVertexAttribArray(attribLoc);
}
